/* ============================================================================
   NURA SOLIS — HOME.JS (Shopify)
   Logique propre à la page d'accueil : panneaux interactifs (values-split),
   carrousel routine, mini-guide recommandeur, showcase couleur.
   ========================================================================== */
(function () {
  "use strict";
  function $(s, c) { return (c || document).querySelector(s); }
  function $all(s, c) { return [].slice.call((c || document).querySelectorAll(s)); }
  function esc(s) { return (s == null ? "" : String(s)).replace(/[&<>"]/g, function (c) { return { "&": "&amp;", "<": "&lt;", ">": "&gt;", '"': "&quot;" }[c]; }); }

  /* --- Values split : le texte change au survol (et au clic sur mobile).
         La hauteur du texte est figée sur la phrase la plus longue pour que
         le cadre gris ne change JAMAIS de taille. --------------------------- */
  $all(".values-split").forEach(function (split) {
    var lead = split.querySelector(".values-split__lead");
    if (!lead) return;
    var def = lead.getAttribute("data-default") || lead.textContent;
    var items = $all(".values-list__item", split);
    var texts = [def].concat(items.map(function (it) { return it.getAttribute("data-text"); }));

    function fitLead() {
      lead.style.height = "auto";
      var max = 0;
      texts.forEach(function (t) { lead.textContent = t; if (lead.scrollHeight > max) max = lead.scrollHeight; });
      lead.textContent = def;
      lead.style.height = max + "px";
    }

    function swap(txt, el) {
      lead.classList.add("is-swapping");
      setTimeout(function () {
        lead.textContent = txt;
        lead.classList.remove("is-swapping");
      }, 200);
      items.forEach(function (x) { x.classList.toggle("is-active", x === el); });
    }

    items.forEach(function (it) {
      var t = it.getAttribute("data-text");
      it.addEventListener("mouseenter", function () { swap(t, it); });
      it.addEventListener("focus", function () { swap(t, it); });
      it.addEventListener("click", function () { swap(t, it); });
    });
    var list = split.querySelector(".values-list");
    if (list) list.addEventListener("mouseleave", function () { swap(def, null); });

    fitLead();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fitLead);
    var rt;
    window.addEventListener("resize", function () { clearTimeout(rt); rt = setTimeout(fitLead, 200); });
  });

  /* ======================= CARROUSEL GÉNÉRIQUE ===========================
     Une diapo visible à la fois, navigation par flèches + points,
     autoplay optionnel (data-autoplay="ms"), pause à l'interaction,
     respect de prefers-reduced-motion. Réutilisé pour la routine. --------- */
  function initCarousel(carousel, opts) {
    opts = opts || {};
    var track = carousel.querySelector(".carousel-track");
    if (!track) return;
    var slides = [].slice.call(track.children);
    if (slides.length < 2) return;

    var controls = document.createElement("div");
    controls.className = "carousel-controls";
    var prev = document.createElement("button");
    prev.type = "button"; prev.className = "carousel-arrow prev"; prev.setAttribute("aria-label", "Précédent");
    prev.innerHTML = '<svg viewBox="0 0 24 24"><path d="M15 5l-7 7 7 7"/></svg>';
    var next = document.createElement("button");
    next.type = "button"; next.className = "carousel-arrow next"; next.setAttribute("aria-label", "Suivant");
    next.innerHTML = '<svg viewBox="0 0 24 24"><path d="M9 5l7 7-7 7"/></svg>';
    var dots = document.createElement("div");
    dots.className = "carousel-dots";
    slides.forEach(function (s, i) {
      var d = document.createElement("button");
      d.type = "button"; d.setAttribute("aria-label", "Aller à la diapo " + (i + 1));
      d.onclick = function () { go(i, true); };
      dots.appendChild(d);
    });
    controls.appendChild(prev); controls.appendChild(dots); controls.appendChild(next);
    carousel.appendChild(controls);
    var dotEls = [].slice.call(dots.children);

    var idx = 0;
    function clamp(i) { return Math.max(0, Math.min(slides.length - 1, i)); }
    function curIndex() { return Math.round(track.scrollLeft / track.clientWidth); }
    function setActive(i) { idx = i; dotEls.forEach(function (d, k) { d.classList.toggle("active", k === i); }); }
    function go(i, user) {
      i = ((i % slides.length) + slides.length) % slides.length;
      track.scrollTo({ left: track.clientWidth * i, behavior: "smooth" });
      setActive(i);
      if (user) restart();
    }
    prev.onclick = function () { go(idx - 1, true); };
    next.onclick = function () { go(idx + 1, true); };
    track.addEventListener("scroll", function () { setActive(clamp(curIndex())); }, { passive: true });
    setActive(0);

    var interval = parseInt(opts.autoplay || carousel.dataset.autoplay || "0", 10);
    var reduce = window.matchMedia("(prefers-reduced-motion:reduce)").matches;
    var timer = null;
    function start() { if (interval > 0 && !reduce && !timer) timer = setInterval(function () { go(idx + 1, false); }, interval); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }
    function restart() { stop(); start(); }
    ["mouseenter", "focusin", "touchstart", "pointerdown"].forEach(function (ev) { carousel.addEventListener(ev, stop, { passive: true }); });
    ["mouseleave", "focusout", "touchend"].forEach(function (ev) { carousel.addEventListener(ev, start, { passive: true }); });
    start();

    var rt;
    window.addEventListener("resize", function () {
      clearTimeout(rt);
      rt = setTimeout(function () { track.scrollTo({ left: track.clientWidth * idx }); }, 150);
    }, { passive: true });
  }

  var routine = $("#routine-carousel");
  if (routine) initCarousel(routine, { autoplay: routine.getAttribute("data-autoplay") });

  /* --- Mini-guide « Quel glow vous correspond ? » ------------------------- */
  var reco = $("#reco");
  if (reco) {
    var dataEl = $("#reco-data");
    var results = {};
    try { results = JSON.parse(dataEl ? dataEl.textContent : "{}"); } catch (e) { results = {}; }
    var note = reco.getAttribute("data-note") || "";
    var answers = [];
    var qWrap = reco.querySelector(".reco__q");
    var resWrap = reco.querySelector(".reco__result");
    var questions = [
      { q: "Vous voulez sublimer…", a: [{ label: "Le corps", value: "corps" }, { label: "Le visage", value: "visage" }] },
      { q: "Quelle intensité recherchez-vous ?", a: [{ label: "Le plus intense possible", value: "ultra" }, { label: "Un hâle dark", value: "dark" }, { label: "Naturel et modulable", value: "naturel" }] }
    ];
    function resolve() {
      if (answers[0] === "visage") return results.visage;
      if (answers[1] === "ultra") return results.ultra;
      if (answers[1] === "dark") return results.dark;
      return results.naturel;
    }
    function renderQuestion(i) {
      resWrap.classList.remove("show");
      qWrap.style.display = "block";
      var q = questions[i];
      qWrap.innerHTML =
        '<div class="reco__progress">Question ' + (i + 1) + " / " + questions.length + "</div>" +
        "<h3>" + esc(q.q) + "</h3>" +
        '<div class="reco__options">' +
          q.a.map(function (o) { return '<button type="button" data-val="' + o.value + '">' + esc(o.label) + "</button>"; }).join("") +
        "</div>";
      qWrap.querySelectorAll("button").forEach(function (b) {
        b.onclick = function () {
          answers[i] = b.dataset.val;
          if (i + 1 < questions.length) renderQuestion(i + 1);
          else renderResult();
        };
      });
    }
    function renderResult() {
      var p = resolve();
      qWrap.style.display = "none";
      if (!p) {
        resWrap.innerHTML = '<p class="reco__note">Recommandation indisponible pour le moment — reliez des produits à cette section dans l\'éditeur de thème.</p><button class="reco__restart" type="button">Recommencer</button>';
      } else {
        resWrap.innerHTML =
          '<div class="reco__progress">Notre recommandation</div>' +
          "<h3>" + esc(p.name) + "</h3>" +
          '<div class="res-card">' +
            '<div class="res-thumb" style="overflow:hidden">' + (p.img ? '<img src="' + p.img + '" alt="' + esc(p.name) + '" style="width:100%;height:100%;object-fit:cover">' : "") + "</div>" +
            "<div><strong>" + esc(p.name) + "</strong><p style=\"color:var(--ink-soft);font-size:.9rem;margin-top:4px\">" + esc(p.sub) + "</p></div>" +
          "</div>" +
          '<a class="btn" href="' + p.url + '">Découvrir ' + esc(p.name) + "</a>" +
          '<p class="reco__note">' + esc(note) + "</p>" +
          '<button class="reco__restart" type="button">Recommencer</button>';
      }
      resWrap.classList.add("show");
      resWrap.querySelector(".reco__restart").onclick = function () { answers = []; renderQuestion(0); };
    }
    renderQuestion(0);
  }

  /* --- Color-shift showcase (fond assorti + panneau d'info central) ------- */
  var stage = $("#stage");
  if (stage) {
    var track = $("#track"), info = $("#stage-info"), dotsWrap = $("#dots");
    var slides = $all(".slide", track);
    if (slides.length) {
      slides.forEach(function (s, i) {
        var d = document.createElement("button"); d.className = "dot"; d.setAttribute("aria-label", "Produit " + (i + 1));
        d.onclick = function () { scrollToIndex(i); };
        dotsWrap.appendChild(d);
      });
      var dots = $all("button", dotsWrap);
      var current = -1;
      function apply(i) {
        if (i === current) return; current = i;
        var s = slides[i];
        stage.style.backgroundColor = s.getAttribute("data-bg");
        stage.classList.toggle("dark", s.getAttribute("data-dark") === "1");
        dots.forEach(function (d, k) { d.classList.toggle("active", k === i); });
        slides.forEach(function (sl, k) { sl.classList.toggle("is-active", k === i); });
        if (info) {
          info.classList.remove("show");
          var url = s.getAttribute("data-url"), variant = s.getAttribute("data-variant"), blurb = s.getAttribute("data-blurb");
          var title = s.getAttribute("data-title") || "";
          info.innerHTML =
            (url ? '<a class="stage-title-btn" href="' + url + '"><h3>' + title + "</h3></a>" : "<h3>" + title + "</h3>") +
            (variant ? '<div class="variant">' + variant + "</div>" : "") +
            (blurb ? '<p class="blurb">' + blurb + "</p>" : "");
          requestAnimationFrame(function () { info.classList.add("show"); });
        }
      }
      function slideCenter(s) { return s.offsetLeft + s.offsetWidth / 2; }
      function nearestIndex() { var c = track.scrollLeft + track.clientWidth / 2, best = 0, bd = Infinity; slides.forEach(function (s, i) { var d = Math.abs(slideCenter(s) - c); if (d < bd) { bd = d; best = i; } }); return best; }
      function scrollToIndex(i) { i = Math.max(0, Math.min(slides.length - 1, i)); track.scrollTo({ left: slideCenter(slides[i]) - track.clientWidth / 2, behavior: "smooth" }); }
      track.addEventListener("scroll", function () { apply(nearestIndex()); }, { passive: true });
      apply(0);
      var pn = $("#st-next"), pp = $("#st-prev");
      if (pn) pn.onclick = function () { scrollToIndex(nearestIndex() + 1); };
      if (pp) pp.onclick = function () { scrollToIndex(nearestIndex() - 1); };
    }
  }
})();
